import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  l2navoptions,
  l3navoptions,
} from "../../Constants/Menus/ConstantMenus";
import "./patientdetails.css";
import "../../../../styles/Common Styles/l2tabnav/l2tabnav.css";
import PatientDetailsRoute from "../../../../Routes/Rpm/PatientDetailsRoute";
import { Link, useLocation, useRouteMatch, useHistory } from "react-router-dom";
import {
  getpatientconsultationhistory,
  getpatientvitalshistory,
  getpatientvitals,
  getpatientname,
  getvitalsettings,
  getpatienthelthdata,
  addlogaction,
} from "../../../../actions/RPMAction";
import { log } from "@opentok/client";

function PatientDetails() {
  let [activeTop, setActiveTop] = useState(0);
  let [patientname, setPatientname] = useState(0);
  const [locationKeys, setLocationKeys] = useState([]);
  let history = useHistory();
  let { path, url } = useRouteMatch();
  const location = useLocation();
  const userData = JSON.parse(localStorage.getItem("userData"));

  const patientId = userData.profileId;
  const status = localStorage.getItem("status");
  // signupData = location.state?.detail
  let [isAction, setIsAction] = useState(false);

  useEffect(() => {
    return history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }

      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);

          // Handle forward event
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);

          // Handle back event
          console.log("back button");

          //history.go(2);
        }
      }
    });
  }, [locationKeys]);

  //localStorage.setItem("patientId", patientId);
  const dispatch = useDispatch();
  useEffect(() => {
    try {
      // dispatch(getpatientvitalshistory(patientId));
      // dispatch(getpatientvitals(patientId));
      // dispatch(getpatientconsultationhistory(patientId));
      // dispatch(getvitalsettings(patientId));
      // dispatch(getpatientname(patientId)).then((res) => {
      //   //   console.log("getpatientname", res)
      //   setPatientname(res.data.info);
      //   // progressIncrementer()
      // });
      // dispatch(getpatienthelthdata(patientId));
      menuload("profile");
    } catch (error) {
      console.log("Error in fetch_clinic_speciality API", error);
    }
  }, []);

  let isTabActive = (tabName) => {
    //localStorage.setItem("PatientName", patientname);

    if (
      location?.pathname === "/rpm/patientdetails" &&
      isAction &&
      tabName === "actionrequired"
    ) {
      if (isAction) {
      }
      return true;
    } else if (
      location?.pathname === "/rpm/patientdetails" &&
      !isAction &&
      tabName === "patientvitals"
    ) {
      return true;
    } else if (location?.pathname === "/rpm/escalatehcp" && !isAction) {
      return true;
    } else if (location?.pathname?.includes(tabName)) {
      return true;
    }
  };

  let isTabVisible = (tabName) => {
    //  console.log(isAction);
    return !isAction && tabName == "actionrequired" ? false : true;
  };
  //{`${path}/${element.component}`}

  //console.log("patientname",patientname)
  let menuload = (componentname) => {
    // console.log("menuload", componentname);
    history.push({
      pathname: path + "/" + componentname,
      state: {
        patientId: patientId,
        page: "patientdetails",
        patientName: patientname,
      },
    });
  };

  console.log("**************history-patient details*************", history);

  return (
    <div className="patient-medical-container">
      {/* <div className="patient-medical-container_header">
               <div className='main-header'> Doctor Name: <b>Dr John Dow</b>, Last Consulted on: <b>01, January, 2022</b></div>
            </div> */}

      <div className="patient-medical-container_header hidden">
        <div className="l2-nav patient-dashboard-l3-nav">
          <ul>
            {l2navoptions.map((element, key) => {
              if (isTabVisible(element.component)) {
                return (
                  <>
                    <li
                      key={key}
                      // className={
                      //   isTabActive(element.component) ? "l2-nav-active" : null
                      // }
                      className="l2-nav-active"
                      onClick={() => {
                        setActiveTop(element.component);
                      }}
                    >
                      <Link
                        onClick={() => {
                          menuload(element.component);
                        }}
                        to={element.component}
                      >
                        {status != "" && status === "Action Taken by Nurse"
                          ? element.name === "Action Required"
                            ? "Next Step Taken"
                            : element.name
                          : element.name}
                      </Link>
                    </li>

                    {key < l2navoptions.length - 1 ? " | " : null}
                  </>
                );
              }
            })}
          </ul>
        </div>
      </div>

      <PatientDetailsRoute isAction />
    </div>
  );
}

export default PatientDetails;
